"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDocumentJobContextV2 = void 0;
const isDocumentJobContextV2 = (context) => {
    const potentialJobContext = context;
    return [
        potentialJobContext.jobId !== undefined,
        potentialJobContext.contractId !== undefined,
        potentialJobContext.contractType !== undefined,
        potentialJobContext.user !== undefined,
        potentialJobContext.documentName !== undefined,
    ].every((value) => value === true);
};
exports.isDocumentJobContextV2 = isDocumentJobContextV2;
